export default function DemoBanner({ onSignUp, onExit }) {
  return (
    <div className="shrink-0 bg-blue-950/60 border-b border-blue-900/60 backdrop-blur-xl">
      <div className="px-3 sm:px-6 py-2.5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
        <p className="text-xs sm:text-sm text-blue-200 leading-snug">
          <span className="font-semibold text-blue-100">You're exploring InsightPulse AI with sample data.</span>{" "}
          Create a free account to analyze your own Excel or CSV files.
        </p>

        <div className="flex items-center gap-2 shrink-0 self-end sm:self-auto">
          <button
            onClick={onExit}
            className="text-xs px-3 py-1.5 rounded-lg text-blue-300 hover:text-white hover:bg-white/5 transition font-medium"
          >
            Exit Demo
          </button>

          <button
            onClick={onSignUp}
            className="text-xs sm:text-sm bg-blue-600 hover:bg-blue-700 transition px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-semibold text-white shadow-lg shadow-blue-900/30 whitespace-nowrap"
          >
            Create Free Account
          </button>
        </div>
      </div>
    </div>
  );
}
